import React from 'react';
import { Tooltip as AntDTooltip } from 'antd';
import type { TooltipProps as AntdTooltipProps } from 'antd';
import classnames from 'classnames';

import cn from './styles.module.scss';

export enum TooltipPlacement {
  Top = 'top',
  Left = 'left',
  Right = 'right',
  Bottom = 'bottom',
  TopLeft = 'topLeft',
  TopRight = 'topRight',
  BottomLeft = 'bottomLeft',
  BottomRight = 'bottomRight',
  LeftTop = 'leftTop',
  LeftBottom = 'leftBottom',
  RightTop = 'rightTop',
  RightBottom = 'rightBottom',
}

export type TooltipProps = Omit<AntdTooltipProps, 'placement'> & {
  placement?: TooltipPlacement;
  className?: string;
};

export function Tooltip({
  placement = TooltipPlacement.Top,
  title,
  children,
  overlayClassName,
  className,
  ...props
}: TooltipProps) {
  return (
    <div className={className}>
      <AntDTooltip
        overlayClassName={classnames(cn.container, overlayClassName)}
        placement={placement}
        title={title}
        {...props}
      >
        <div>
          {children}
        </div>
      </AntDTooltip>
    </div>
  );
}
